import { BusinessUnitKey } from '@/modules/bu/bu.types';
import type { RouteRecordRaw } from 'vue-router';
import routes from './routes/flokee.routes';

// Discovered by the BU registry; see `src/modules/bu/registry.ts`.
export const key = BusinessUnitKey.Flokee;
export default routes;

// Unprefixed paths this product used to own, kept for old links.
export const legacyRoutes: RouteRecordRaw[] = [
  {
    path: '/auth/:pathMatch(.*)*',
    redirect: (to) => `/flokee/auth/${to.params.pathMatch ?? ''}`,
  },
  {
    path: '/wizard/:pathMatch(.*)*',
    redirect: (to) => `/flokee/wizard/${to.params.pathMatch ?? ''}`,
  },
  {
    path: '/widgets/:pathMatch(.*)*',
    redirect: (to) => `/flokee/widgets/${to.params.pathMatch ?? ''}`,
  },
  {
    path: '/store/settings/:pathMatch(.*)*',
    redirect: (to) => `/flokee/store/settings/${to.params.pathMatch ?? ''}`,
  },
  {
    path: '/store/connections/:pathMatch(.*)*',
    redirect: (to) => `/flokee/store/connections/${to.params.pathMatch ?? ''}`,
  },
  {
    path: '/store/:pathMatch(.*)*',
    redirect: (to) => `/flokee/store/${to.params.pathMatch ?? ''}`,
  },
  {
    path: '/invest',
    redirect: '/flokee/invest',
  },
  {
    path: '/select-account',
    redirect: '/flokee/select-account',
  },
];
